const SET_SIGN_IN_IS_VISIBLE = 'SET_SIGN_IN_IS_VISIBLE';

export { SET_SIGN_IN_IS_VISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignIn/constants.js